module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 7 15",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#facebook",
      toString: function () {
        return this.url;
      }
    }